import dom from "../../../../../dist/jsx-render/dom";
import { ButtonComponent } from "../../../../Components/ButtonComponent";
import { app } from "../../../../Frame/App";
import { active } from "d3";

class MatrixData {
    public id: string;
    public leftHeader: HTMLElement;
    public leftContent: HTMLElement;
    public rightHeader: HTMLElement;
    public rightContent: HTMLElement;

    init() {
        if (this.rightContent) {
            this.rightContent.addEventListener("scroll", this.onScroll);
        }
    }

    onScroll = (ev: Event) => {
        if (this.rightHeader) {
            this.rightHeader.scrollLeft = this.rightContent.scrollLeft;
        }
        if (this.leftContent) {
            this.leftContent.scrollTop = this.rightContent.scrollTop;
        }
    }

    dispose() {
        if (this.rightContent) {
            this.rightContent.removeEventListener("scroll", this.onScroll);
        }
    }
}

/** Fullscreen module for dynamic controls. Extracted from MatrixControl, can be used for 
 * MatrixControl or MatrixGroup. It would need some more refactoring
 * and renaming of css classes to be used for other dynamic controls. */
export class FullscreenDisplay {

    /**
     * This is the element, the contrent gets appended to when the fullscreen display is closed.
     */
    private container: HTMLElement;
    private overlay: HTMLElement;
    private fullScreenButton: HTMLElement;

    private matrixData: MatrixData[] = [];

    /** 
     *  This is the HTML Element that will be displayed in fullscreen and the button is rendered next to.
     * */
    private hoverElement: HTMLElement;

    /** Display a caption if set. */
    private caption?: string;

    public createFullscreenButton = (hoverElement: HTMLElement, containerElement: HTMLElement, caption?: string) => {
        this.hoverElement = hoverElement;
        this.container = containerElement;
        this.caption = caption;
        //this.hoverElement.addEventListener('mouseenter', this.showFullscreenButton);

        let button: HTMLElement = (
            <div className="fullscreen-button pointer">
                <i className="btn-full fal fa-expand-alt pointer" title="fullscreen"></i>
            </div>
        );
        this.fullScreenButton = button;

        if (this.hoverElement.classList.contains("matrix-tables")) {
            this.container.insertBefore(button, this.container.firstElementChild);
        }
        else {
            this.hoverElement.appendChild(button);
        }

        (button.firstElementChild as HTMLElement)?.addEventListener("click", (ev: MouseEvent) => {
            if (this.overlay) {
                this.closeFullscreen(ev);
            }
            else {
                this.showFullscreen(ev);
            }
        });
    }

    //private showFullscreenButton = (event: MouseEvent) => {
    //    let element = event.target as HTMLElement;
    //    let button: HTMLElement = <ButtonComponent
    //        additionalCssClasses="icon-edit fa fa-arrows-alt fullscreen-button cursor-pointer"
    //        action={this.showFullscreen}
    //        altText={Resources.Common.fullscreen} />

    //    this.fullScreenButton = button;

    //    element.appendChild(button);
    //    element.addEventListener('mouseleave', this.hideFullscreenButton);
    //}

    private hideFullscreenButton = (event: MouseEvent) => {
        app.destroyDomElements(this.fullScreenButton);
    }

    private showFullscreen = (event: Event) => {
        this.overlay = <div className="fullscreen-overlay edit-form">
            <div className="header">
                <div className="caption">
                    <h5>
                        {this.caption ? this.caption : ""}
                    </h5>
                </div>
                <ButtonComponent additionalCssClasses="icon-edit fa fa-times cursor-pointer close-right"
                    action={this.closeFullscreen}
                    altText={Resources.Common.close} />
            </div>
        </div>;

        this.hideFullscreenButton(event as MouseEvent);

        this.overlay.appendChild(this.hoverElement);

        document.body.appendChild(this.overlay);

        // create data for all matrices
        let matrices = document.getElementsByClassName("matrix-tables");
        for (let i = 0; i < matrices.length; i++) {
            let data: MatrixData = new MatrixData();
            data.id = matrices.item(i).getAttribute("data-id");
            data.leftHeader = document.getElementById("mc_leftmatrixheader_" + data.id);
            data.leftContent = document.getElementById("mc_leftmatrixrows_" + data.id);
            data.rightHeader = document.getElementById("mc_rightmatrixheader_" + data.id);
            data.rightContent = document.getElementById("mc_rightmatrixrows_" + data.id);
            data.init();
            this.matrixData.push(data);
        }

        // register on tab changed event
        $(this.overlay).find('a[data-toggle="tab"]').on('shown.bs.tab', this.onTabChanged);

        this.resizeMatrix();
        window.addEventListener("resize", this.onResize);
    }

    private closeFullscreen = (event: Event) => {
        for (let data of this.matrixData) {
            data.dispose();
        }
        window.removeEventListener("resize", this.onResize);
        $(this.overlay).find('a[data-toggle="tab"]').off('shown.bs.tab', this.onTabChanged);
        let overlay = document.body.querySelector(".fullscreen-overlay") as HTMLDivElement;
        this.container.appendChild(this.hoverElement);
        app.destroyDomElements(overlay);
        this.overlay = null;
        this.createFullscreenButton(this.hoverElement, this.container, this.caption);
    }

    onTabChanged = (e) => {
        this.resizeMatrix();
    }

    onResize = (ev: UIEvent) => {
        this.resizeMatrix();
    }

    private resizeMatrix() {
        let activeTab = this.overlay.querySelector(".nav-link.active");
        if (activeTab) {
            for (let data of this.matrixData) {
                if (data.id == activeTab.getAttribute("data-id")) {
                    if (data.rightContent) {
                        if (data.rightHeader) {
                            data.rightHeader.style.width = data.rightContent.clientWidth + "px";
                        }
                        if (data.leftContent) {
                            data.leftContent.style.height = data.rightContent.clientHeight + "px";
                        }
                    }
                }
            }
        }
    }
}